import {
  Component,
  Input
} from '@angular/core';

import {MatDialog, MatDialogConfig} from "@angular/material";
import { NodesListService } from '../services/nodesList.service'
import { TreeDiagramNode } from "../classes/node.class"
import { DomSanitizer } from "@angular/platform-browser"
import { TreeDiagramNodeMaker } from "../classes/node-maker.class"
import { HumanResourcesComponent} from '../../../views/human-resources/human-resources.component'
@Component({
  selector: '[treeDiagramNode]',
  styleUrls: [ './node.component.scss' ],
  templateUrl: './node.component.html',
})
export class Node {
  public node: TreeDiagramNode | TreeDiagramNodeMaker;
  public childrenTransform;
  public modal: boolean = false;



  constructor(private nodesSrv: NodesListService,  private sanitizer: DomSanitizer,private human: HumanResourcesComponent){

  }
  @Input() set treeDiagramNode(guid) {
    this.node = this.nodesSrv.getNode(guid)
    this.childrenTransform = this.sanitizer.bypassSecurityTrustStyle(`translate(calc(-50% + ${Math.round(this.node.width/2)}px), 45px)`)
  }





}



// WEBPACK FOOTER //
// ./src/app/components/angular2-tree-diagram/node/node.component.ts